const NekoTheme = {

  // COLORS

  black: 'black',
  blackRGB: '0, 0, 0',
  blue: '#007cba',
  blueRGB: '0, 124, 186',
  deepBlue: '#134575',
  finderBorder: '#DEDEDE',
  lightBlue: '#EBF3FF',
  lightGray: '#F1F1F1',
  gray: '#E8E8E8',
  green: '#0EA480',
  darkGray: '#A0A0A0',
  disabledForm: '#828282',
  orange: '#daa827',
  overlay: 'rgba(16, 16, 16, 0.92)',
  red: '#ba4300',
  redHighlight: '#de5307',
  header: '#134675',
  proGray: '#7F8EA0',
  progress: '#8414a8',
  tableGray: '#FAFAFA',
  yellow: '#e4b42b',
  yellowRGB: '224, 156, 54',
  white: 'white',

  // FONT

  fontFamily: 'Lato',
  fontSizeH1: '24px',
  fontSizeH2: '18px',
  fontSizeText: '13px',
  fontSizeSmall: '12px',

  // SHADOW

  lightShadow: '0px 0px 10px rgba(0,0,0,0.1)',
};

export default NekoTheme;
